import { getLoggedInUser, setAuthData } from "./authHelper";

// While an admin is signed in as a customer, the admin's own session is set aside under this key in the same
// storage as the active session, so "Return to admin" restores it without signing in again.
const STASH_KEY = "impersonation.adminSession";

const activeStorage = () => (!localStorage.getItem("token") && sessionStorage.getItem("token") ? sessionStorage : localStorage);

const readStash = () => {
  for (const storage of [localStorage, sessionStorage]) {
    const value = storage.getItem(STASH_KEY);
    if (!value) continue;
    try {
      const stash = JSON.parse(value);
      if (stash?.token) return { storage, stash };
    } catch {
      storage.removeItem(STASH_KEY);
    }
  }
  return null;
};

export const clearImpersonationStash = () => {
  localStorage.removeItem(STASH_KEY);
  sessionStorage.removeItem(STASH_KEY);
};

export const isImpersonating = () => Boolean(readStash() || getLoggedInUser()?.impersonation);

// Called with the admin API's response; the admin's current session is kept so it can be restored later.
export const beginImpersonation = ({ token, user }) => {
  const storage = activeStorage();
  const adminToken = storage.getItem("token");
  if (!adminToken || !token) throw new Error("Your admin session could not be preserved. Sign in again and retry.");
  // Starting a second session from inside one keeps the original admin session, never the customer's.
  if (!readStash()) storage.setItem(STASH_KEY, JSON.stringify({ token: adminToken, user: storage.getItem("user") }));
  setAuthData(token, user);
};

// Puts the admin's own session back. Returns false when there was nothing to restore.
export const restoreAdminSession = () => {
  const found = readStash();
  clearImpersonationStash();
  if (!found) return false;
  const { storage, stash } = found;
  storage.setItem("token", stash.token);
  if (stash.user) storage.setItem("user", stash.user);
  else storage.removeItem("user");
  window.dispatchEvent(new Event("auth:user-updated"));
  return true;
};
